import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { useAuthStore } from '../store/authStore';

const NotFound: React.FC = () => {
  const { isAuthenticated } = useAuthStore();
  const oidc = useAuth();
  const location = useLocation();
  // The portal signs learners in via ZewstID/OIDC (react-oidc-context), while
  // legacy IDE flows use the local auth store. Treat either as "signed in" so a
  // real learner never sees the "Go to sign in" CTA on a 404.
  const signedIn = isAuthenticated || oidc.isAuthenticated;
  const home = signedIn ? '/portal' : '/login';

  return (
    <div
      role="alert"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: 24,
        gap: 16,
        fontFamily: 'system-ui, sans-serif',
        background: '#1e1e1e',
        color: '#e0e0e0',
        textAlign: 'center',
      }}
    >
      <div style={{ fontSize: 96, fontWeight: 700, lineHeight: 1, color: '#3b82f6' }}>404</div>
      <h1 style={{ margin: 0, fontSize: 28 }}>Page not found</h1>
      <p style={{ margin: 0, maxWidth: 480, color: '#a0a0a0' }}>
        We couldn't find <code style={{ color: '#e0e0e0' }}>{location.pathname}</code>. It may have
        been moved, or the link is wrong.
      </p>
      <Link
        to={home}
        style={{
          marginTop: 12,
          padding: '10px 20px',
          background: '#3b82f6',
          color: '#fff',
          textDecoration: 'none',
          borderRadius: 6,
          fontWeight: 500,
        }}
      >
        {signedIn ? 'Back to portal' : 'Go to sign in'}
      </Link>
    </div>
  );
};

export default NotFound;
